module.exports = __webpack_public_path__ + "static/flags/MA-fb0ccea9b66c40caf0a2aeba5349d4d0.gif";